import { html, css } from 'lit';
import { property } from 'lit/decorators.js';
import { BaseWidget } from "../base-widget";

// Quick link default widget implementation.  This has a static content
export class InformationalDefault extends BaseWidget {
    static get styles() {
        return css`
          .default-widget-button { cursor: default !important; line-height: 4px;min-width: auto}
          .button {border: none;color: #ffffff !important;background-color: #004693 !important;border-radius: 5px;outline: none;text-decoration: none;min-width: 7rem;padding: 0.6rem 1.3rem !important;display: inline-block;text-align: center;text-decoration: none;}
          .widget-content-class{padding: 3px;}
          .widgetbox {
                border: 1px solid #75787b;
                border-radius: 5px;
                background: #ffffff;
                margin-right: 15px;
                margin-bottom: 15px;
                margin-top: 10px;
                min-height: 40px;
            }
        `;
    }
    // Overriding content part of the widget.render().  We just need a slot here!
    getContentLoaderSlot() {
        return html`
            <div class="widget-content-class">
            To add Informational widgets, click the <button class="button button_style default-widget-button">Add Widgets</button> button.  Under the Informational Widgets section, select widgets you would like to add to the right-most column of the landing page.
            </div>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'informational-default': InformationalDefault;
    }
}

